export default __webpack_public_path__ + "static/media/live-casino-rebate-ico.e2962c34.svg";